module.exports = __webpack_public_path__ + "static/media/ios-subway.9717dedf.svg";